import { TenantProvider } from './tenant.provider';

export function appInitializer(tenantProvider: TenantProvider) {
    return () => tenantProvider.load();
}
